if ($('.js-main-slider').length) {

    const mainSlider = new Swiper(".js-main-slider", {
        slidesPerView: 1,
        effect: 'fade',
        speed: 750,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".js-main-slider-next",
            prevEl: ".js-main-slider-prev",
        },
        pagination: {
            el: '.js-main-slider-pagination',
            type: 'bullets',
            clickable: true
        },
        autoplay: {
            delay: 10000,         // 5000 мс = 5 секунд
            disableOnInteraction: false, // чтобы не отключался после клика
        },
    });
}
